import { useMemo } from 'react';
import { History } from 'lucide-react';
import { EmptyState, PageHeader, SkeletonList } from '@/components/ui';
import { SignListItem } from '@/components/SignListItem';
import { useCategoryNames, useRecentSigns, useSignStates } from '@/hooks/useCatalogQueries';

export function RecentPage(): React.ReactElement {
  const recent = useRecentSigns(50);
  const categoryNames = useCategoryNames();

  const ids = useMemo(() => (recent ?? []).map((entry) => entry.sign.id), [recent]);
  const states = useSignStates(ids);

  return (
    <>
      <PageHeader title="Recentes" backTo="/" />

      {recent === undefined && <SkeletonList rows={6} />}

      {recent?.length === 0 && (
        <EmptyState
          icon={<History size={40} aria-hidden />}
          title="Nada visto ainda"
          description="Os sinais que você abrir aparecem aqui, do mais recente para o mais antigo."
        />
      )}

      {recent && recent.length > 0 && (
        <ul className="flex flex-col pb-4">
          {recent.map(({ sign }) => (
            <SignListItem
              key={sign.id}
              sign={sign}
              state={states?.get(sign.id)}
              categoryName={categoryNames?.get(sign.categoryId)}
            />
          ))}
        </ul>
      )}
    </>
  );
}
